import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-k8s-release",
  "use": "oc-res-k8s-release-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-k8s-release\"><path d=\"M862.016 262.784L516.16 659.2l265.024 88.32 80.832-484.8z m-49.28-40.96L220.032 560.64l230.336 76.8 362.368-415.488zM512 725.376V864a32 32 0 1 1-64 0V704L131.84 598.656a32 32 0 0 1-5.76-58.176l775.424-443.008a32 32 0 0 1 47.36 33.024l-110.72 664.576a32 32 0 0 1-41.664 25.088L512 725.312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol